// extracted by mini-css-extract-plugin
export default {"wrapper":"GameError_wrapper--Mxt","text":"GameError_text--BIW","buttonLinkWrapper":"GameError_buttonLinkWrapper--o8B","image":"GameError_image--xfo"};